module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "software-requests"
  }, [_c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (_vm.software && _vm.selectionAvailable === true) ? _c('div', {
    staticClass: "panel-body"
  }, [(_vm.text && _vm.text.disclaimer) ? _c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.text.disclaimer[0].text)
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "confirmation"
  }, [_vm._v("I've read and understand these instructions"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.instructionsConfirmed),
      expression: "instructionsConfirmed"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.instructionsConfirmed) ? _vm._i(_vm.instructionsConfirmed, null) > -1 : (_vm.instructionsConfirmed)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.instructionsConfirmed,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.instructionsConfirmed = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.instructionsConfirmed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.instructionsConfirmed = $$c
        }
      }
    }
  })]), _vm._v(" "), (_vm.instructionsConfirmed) ? _c('div', [_c('ul', {
    staticClass: "software"
  }, _vm._l((_vm.software), function(program) {
    return _c('li', [_c('div', [_c('img', {
      attrs: {
        "src": program.icon
      }
    }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(program.name) + " "), (_vm.paymentRequired === true) ? _c('span', [_vm._v("(" + _vm._s(_vm._f("currency")(program.price)) + ") CAD")]) : _vm._e()])]), _vm._v(" "), _c('div', [(!_vm.hasSelectedSoftware) ? _c('select', {
      staticClass: "form-control select-software",
      on: {
        "change": function($event) {
          _vm.selectSoftware(program.id, $event)
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "true"
      }
    }, [_vm._v("I'll Need this for Next Term")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "false"
      }
    }, [_vm._v("I've Already Purchased This")])]) : _c('span', [_vm._v("Please check the "), _c('router-link', {
      attrs: {
        "to": "/software-keys"
      }
    }, [_vm._v("Keys")]), _vm._v(" page for your software keys")], 1)])])
  })), _vm._v(" "), (!_vm.hasSelectedSoftware) ? _c('div', {
    staticClass: "subtotal"
  }, [_c('h4', [(_vm.paymentRequired === true) ? _c('span', [_vm._v("Subtotal: " + _vm._s(_vm._f("currency")(_vm.subTotal)) + " CAD")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitRequest()
      }
    }
  }, [_vm._v("Confirm Needed Software")])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectionAvailable === false) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.htmlify(_vm.message))
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Software Request Form")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-71764835!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SoftwareRequests.vue
// module id = 2076
// module chunks = 2